import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import packageJson from '../../package.json'
import i18n from '@store/i18n'

const buildDateGreaterThan = (latestDate, currentDate) => {
    return Number(latestDate) > Number(currentDate)
}

const UpdateDialog = () => {
    const { t } = useTranslation('boot')
    const [showUpdateDialog, setShowUpdateDialog] = useState(false)

    useEffect(() => {
        const checkInterval = 60 * 1000

        const checkForUpdates = async () => {
            try {
                const response = await fetch('/meta.json?date=' + new Date().getTime())
                if (!response.ok) {
                    console.log('Failed to fetch meta.json')
                }
                const meta = await response.json()
                if (!meta.buildDate) {
                    console.log('Invalid meta.json format')
                }

                const shouldForceRefresh = buildDateGreaterThan(meta.buildDate, packageJson.buildDate)
                if (shouldForceRefresh) {
                    if (!i18n.hasResourceBundle(i18n.language, 'boot')) {
                        await i18n.loadNamespaces('boot')
                    }
                    setShowUpdateDialog(true)
                } else {
                    setShowUpdateDialog(false)
                }
            } catch (error) {
                console.error('Error fetching update info:', error)
            }
        }

        checkForUpdates()
        const intervalId = setInterval(checkForUpdates, checkInterval)

        return () => {
            clearInterval(intervalId)
        }
    }, [])

    const refreshCacheAndReload = async () => {
        try {
            setShowUpdateDialog(false)

            if ('serviceWorker' in navigator) {
                const registrations = await navigator.serviceWorker.getRegistrations()
                await Promise.all(registrations.map((registration) => registration.unregister()))
            }

            if (window.caches && caches.keys) {
                const names = await caches.keys()
                await Promise.all(names.map((name) => caches.delete(name)))
            }

            window.location.replace('/login?updated=' + Date.now())
        } catch (error) {
            console.error('Error refreshing cache and reloading:', error)
            window.location.replace('/clear-cache.html?auto=1&clear_persist=false')
        }
    }

    return (
        <>
            {showUpdateDialog && (
                <div className="toast-notification">
                    <div className="toast-content">
                        <h4>{t('update_available')}!</h4>
                        <p>{t('please_reload_the_page_to_get_the_latest_version')}</p>
                        <button onClick={() => refreshCacheAndReload()}>{t('confirm')}</button>
                    </div>
                </div>
            )}
        </>
    )
}

export default UpdateDialog
